import { addMethod, string } from 'yup'
import { isValidPhoneNumber } from 'react-phone-number-input'

addMethod(string, 'phone', function phoneValidator(message) {
  return this.test('valid', message, function isValidPhone(value) {
    return isValidPhoneNumber(value)
  })
})
